import { useId } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material'
import { ExpandMore } from '@vedmarket/ui-kit'
import { COLORS } from 'config/constants'

const ApplicationSectionAccordion = ({
  title,
  icon,
  children,
}: ApplicationSectionAccordionProps) => {
  const accordionId = useId()

  return (
    <Accordion defaultExpanded sx={{ boxShadow: 'none' }}>
      <AccordionSummary
        expandIcon={<ExpandMore width={32} height={32} />}
        id={`${accordionId}-summary`}
        aria-controls={`${accordionId}-content`}
        sx={{
          padding: '12px 24px',
        }}
      >
        <Typography
          variant='h5'
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            fontWeight: 700,
          }}
        >
          <Box
            component='span'
            sx={{
              display: 'flex',
              color: COLORS.LIGHT_TEXT_DISABLED_OPACITY,
              flexShrink: 0,
            }}
          >
            {icon}
          </Box>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

export default ApplicationSectionAccordion
